import { render } from "./TenantInvitationList.vue?vue&type=template&id=4ce91a36&scoped=true"
import script from "./TenantInvitationList.vue?vue&type=script&lang=js"
export * from "./TenantInvitationList.vue?vue&type=script&lang=js"

import "./TenantInvitationList.vue?vue&type=style&index=0&id=4ce91a36&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce91a36"]])

export default __exports__